import { atom } from 'recoil';

/**
 * Set this to raise a full-stop error in the app
 */
export const errorState = atom<any>({
  key: 'sd:error',
  default: undefined
});
